module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.2.2-99.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.2.2.md
// module id = 516
// module chunks = 312